import React from "react";
import { FiCalendar, FiSmartphone } from "react-icons/fi";
import { MdQrCodeScanner } from "react-icons/md";

const PublicLanding: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 flex flex-col">
      <header className="px-6 py-5 border-b border-sbBorder bg-white">
        <div className="max-w-3xl mx-auto flex items-center gap-2">
          <div className="w-9 h-9 rounded-md bg-[#0F3CBE] flex items-center justify-center text-white font-bold">
            D
          </div>
          <span className="text-lg font-semibold text-modalText">DocTrue</span>
        </div>
      </header>

      <main className="flex-1 px-6 py-12 sm:py-16">
        <div className="max-w-3xl mx-auto">
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl font-bold text-modalText leading-tight">
              Book your hospital appointment in seconds
            </h1>
            <p className="mt-4 text-base sm:text-lg text-queueText max-w-xl mx-auto">
              No app, no signup, no wait. Just scan your hospital's QR code and
              pick a time that works for you.
            </p>
          </div>

          <div className="mt-10 sm:mt-12 bg-white border border-sbBorder rounded-2xl p-6 sm:p-8 shadow-sm">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-[#EAF0FF] flex items-center justify-center flex-shrink-0">
                <MdQrCodeScanner className="w-6 h-6 text-[#0F3CBE]" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-modalText">
                  Scan the hospital's QR to begin
                </h2>
                <p className="mt-1 text-sm text-queueText">
                  Each hospital has a unique booking QR code displayed at
                  reception or shared on their channels. Scanning it will open
                  your hospital's booking page on this site.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <Step
              icon={<MdQrCodeScanner className="w-5 h-5" />}
              title="1. Scan"
              text="Scan the QR code at your hospital."
            />
            <Step
              icon={<FiCalendar className="w-5 h-5" />}
              title="2. Pick a slot"
              text="Choose a doctor, date and slot that works for you."
            />
            <Step
              icon={<FiSmartphone className="w-5 h-5" />}
              title="3. Confirm"
              text="Get your booking confirmation on WhatsApp."
            />
          </div>

          <div className="mt-12 text-center">
            <p className="text-xs text-queueText">
              Don't have a QR code? Ask your hospital reception for the booking
              link.
            </p>
          </div>
        </div>
      </main>

      <footer className="px-6 py-6 border-t border-sbBorder bg-white">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
          <span className="text-xs text-queueText">
            Powered by <span className="font-semibold text-[#0F3CBE]">DocTrue</span>
          </span>
          <span className="text-xs text-queueText">
            For hospitals, by hospitals.
          </span>
        </div>
      </footer>
    </div>
  );
};

const Step: React.FC<{
  icon: React.ReactNode;
  title: string;
  text: string;
}> = ({ icon, title, text }) => (
  <div className="bg-white border border-sbBorder rounded-xl p-4">
    <div className="w-9 h-9 rounded-lg bg-[#EAF0FF] text-[#0F3CBE] flex items-center justify-center">
      {icon}
    </div>
    <h3 className="mt-3 text-sm font-semibold text-modalText">{title}</h3>
    <p className="mt-1 text-xs text-queueText leading-relaxed">{text}</p>
  </div>
);

export default PublicLanding;
